import { AxiosResponse } from 'axios'

export const getResponseData = <Response>(response: AxiosResponse<Response>) => response.data
